import ClauseTree from './ClauseTree';

export default ClauseTree;
